import {Directive, ElementRef, Input} from '@angular/core';
import {Editable} from '../models/editable.model';

@Directive({
    selector: '[scrollToEditable]',
    standalone: false
})
export class ScrollToEditableDirective {

    constructor(private el: ElementRef) {
    }

    @Input('scrollToEditable')
    public set editable(editable: Editable) {
        if (editable && editable.__edited) {
            this.el.nativeElement.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }
}
